import { styled } from "styled-components";

export const ColumnStyle = styled.div`
  flex-direction: column;
  width: 100%;
`;
